import React, { useEffect, useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CRow,
  CSpinner,
} from "@coreui/react"
import CIcon from "@coreui/icons-react"
import { cilFingerprint, cilLockLocked, cilUser } from "@coreui/icons"
import { useDispatch, useSelector } from "react-redux"
import { authLogin } from "src/store/Slices/AuthSlice"
import { CFormInputWithMaskPhone } from "src/components/Masks/Masks"
import backgroundImage from "../../assets/background.jpg"
import ReactInputMask from "react-input-mask"
import ChangePasswordModal from "../Accounts/Users/Modals/ChangePasswordModal"

const Login = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  const [loading, setLoading] = useState(false)
  const [mask, setMask] = useState(true)
  const [visibleHost, setVisibleHost] = useState(false)
  const [isChangePasswordModal, setIsChangePasswordModal] = useState(false)
  const [baseUrl, setBaseUrl] = useState(
    localStorage.getItem("baseUrl")
      ? localStorage.getItem("baseUrl")
      : "http://"
  )

  const onClickLogin = async () => {
  setLoading(true)
  dispatch(authLogin({ login: username, password: password })).then(
    (result) => { 
      localStorage.setItem("username", username.replace(/[-() ]/g, ""))
      setLoading(false)
      
      if(result?.payload?.response?.data?.errorMessages?.[0]?.errorMessage === "Пароль устарел") {
        setIsChangePasswordModal(true)
      }
    }
  )
}

  const handlePhoneChange = (e) => {
    console.log(e)
    let value = e

    if (value.startsWith("+7") && value.length === 12 && !value.includes(" ")) {
      const numbers = value.slice(2)
      value = `+7 (${numbers.slice(0, 3)}) ${numbers.slice(
        3,
        6
      )}-${numbers.slice(6, 8)}-${numbers.slice(8, 10)}`
    }

    setUsername(value)
  }

  return (
    <>
     <ChangePasswordModal
        visible={isChangePasswordModal}
        setVisible={setIsChangePasswordModal}
        username={username}
      />
      <div
        style={{
          // backgroundColor: '#0F0F0F',
          backgroundImage: `url(${backgroundImage})`,
        }}
        className=' min-vh-100 d-flex flex-row align-items-center'
      >
        <CContainer>
          <CRow className='justify-content-center'>
            <CCol md={6}>
              <CCardGroup>
                <CCard
                  style={{
                    borderColor: "#b35fce",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    backgroundImage:
                      "linear-gradient(0.308turn,rgba(21,21,21,1) 0%,rgba(35,35,35,1) 100%)",
                  }}
                  className='text-white p-4'
                >
                  <CCardBody>
                    <CForm>
                      {visibleHost && (
                        <div style={{ display: "flex" }}>
                          <CFormInput
                            value={baseUrl}
                            onChange={(e) => setBaseUrl(e.target.value)}
                            placeholder='baseUrl'
                          />
                          <CButton
                            onClick={() => {
                              localStorage.setItem("baseUrl", baseUrl)
                              setVisibleHost(false)
                            }}
                            style={{ color: "white" }}
                          >
                            Установить
                          </CButton>
                        </div>
                      )}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <h1>Войти</h1>
                        <CIcon
                          onClick={() => setVisibleHost((prev) => !prev)}
                          style={{
                            cursor: "pointer",
                            transform: "translate(100%, -100%)",
                          }}
                          icon={cilFingerprint}
                        />
                      </div>
                      <p>Войдите в свой аккаунт</p>
                      <CInputGroup className='mb-3'>
                        <CInputGroupText>
                          <CIcon icon={cilUser} />
                        </CInputGroupText>
                        {mask ? (
                          <ReactInputMask
                            mask='+9 (999) 999-99-99'
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            className='form-control'
                            placeholder='+7 (___) ___-__-__'
                          />
                        ) : (
                          <CFormInput
                            value={username}
                            onChange={(e) => {
                              setUsername(e.currentTarget.value)
                            }}
                          />
                        )}
                      </CInputGroup>
                      <CInputGroup className='mb-4'>
                        <CInputGroupText>
                          <CIcon icon={cilLockLocked} />
                        </CInputGroupText>
                        <CFormInput
                          value={password}
                          type='password'
                          placeholder='Пароль'
                          onChange={(e) => setPassword(e.currentTarget.value)}
                          onKeyDown={(e) => e.keyCode === 13 && onClickLogin()}
                        />
                      </CInputGroup>
                      <CRow>
                        <CCol
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                          xs={5}
                        >
                          {!loading ? (
                            <CButton
                              style={{ color: "#fff" }}
                              onClick={onClickLogin}
                              className='px-4'
                            >
                              Войти
                            </CButton>
                          ) : (
                            <CSpinner color='primary' />
                          )}
                          <CButton
                            style={{ cursor: "default", opacity: "0" }}
                            onClick={() => setMask(!mask)}
                          >
                            odkg
                          </CButton>
                        </CCol>
                      </CRow>
                    </CForm>
                  </CCardBody>
                </CCard>
              </CCardGroup>
            </CCol>
          </CRow>
        </CContainer>
      </div>
    </>
  )
}

export default Login
